/* global document, FileReader */

import React from 'react'
import PropTypes from 'prop-types'

import CircularProgress from 'material-ui/CircularProgress'

import addPhotoIcon from 'resources/add_photo_icon.png'
import Analytics from 'infra/analytics/Analytics'

export default class PhotosAddItem extends React.Component {

  static propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    onAdd: PropTypes.func.isRequired
  }

  constructor () {
    super()
    this.state = {
      loading: false
    }
  }

  finishUpload = () => {
    this.setState({loading: false})
    Analytics.track(Analytics.JOB_IMAGE_UPLOADED)
  }

  onFileInputChange = (e) => {
    const file = e.target.files[0]
    if (!file.type.match('png|jpe?g|gif')){
      //TODO: raise alert to only upload pictures
      return
    }
    const reader = new FileReader()
    reader.onload = (e) => this.props.onAdd(e, file, e.target.result, this.finishUpload)
    this.setState({loading: true})
    reader.readAsDataURL(file)
  }

  triggerInput = () => {
    document.querySelector('input[type=\'file\']').click()
  }

  render() {
    return (
      <div style={styles.container} onClick={this.triggerInput}>
        {this.state.loading
          ? <div style={styles.content(this.props.width, this.props.height)}>
            <CircularProgress
              size={40} thickness={2} color='#527da3'/>
          </div>
          : <div style={styles.content(this.props.width, this.props.height)}>
            <div style={styles.control(this.props.width, this.props.height)}>
              <img src={addPhotoIcon} width={26} height={21} />
              <div style={styles.addPhotoText}>Add photo</div>
            </div>
            <input style={styles.input} type='file' onChange={this.onFileInputChange}
              multiple/>
          </div>
        }
      </div>
    )
  }

}

const styles = {

  container: {
    cursor: 'pointer',
    marginRight: 6
  },

  content: (width, height) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width,
    height: height
  }),

  control: (width, height) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 3,
    backgroundColor: '#fefefe',
    border: '1px solid #e2e2e2',
    width: width-2,
    height: height-2
  }),

  input: {
    display: 'none'
  },

  addPhotoText: {
    color: '#757575',
    fontSize: 14,
    marginTop: 4,
    textAlign: 'center'
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/photos/PhotosAddItem.js